import { SmartLineItem, SmartLineItemsItem } from "./smart-line-item.model";

export interface BetbuilderItem {
  BetBuilderId: string;
  EventId: string;
  EventName: string;
  MarketInfoList: {
    GameName: string;
    ResultId: string;
    ResultName: string;
  }[];
  Odd: number;
  SportHandle: string;
  StartDate: string;
}

export const createBetBuilderLineItem = (betbuilderItem: BetbuilderItem) => {
  const betbuilderLineItem: SmartLineItem = {
    Amount: 1,
    AmountLocal: 1,
    BetBuilderId: betbuilderItem.BetBuilderId,
    BetType: null,
    CanBeEachWay: false,
    CountryId: "",
    Date: null,
    Description: "",
    downOdd: false,
    EventDate: "",
    EventId: betbuilderItem.EventId,
    EventName: betbuilderItem.EventName,
    GameId: "",
    GameLocked: false,
    GameSpecialOddsValue: "",
    Id: "",
    Index: 0,
    ItemId: 0,
    LineErrorMessages: [],
    LineErrors: [],
    Name: "",
    NodeId: null,
    NotAvailable: false,
    Odd: betbuilderItem.Odd,
    PotentialWin: 0,
    ResultsNr: "",
    Selected: false,
    SmartLineItems: setBetBuilderSmartLineItems(betbuilderItem.MarketInfoList),
    SportHandle: "",
    TicketNumber: "",
    TotalBets: 0,
    TotalPotentialWin: 0,
    TotalPotentialWinWithoutBoost: 0,
    Type: 0,
    upOdd: false,
    IsLive: false,
  };
  return betbuilderLineItem;
};

export const setBetBuilderSmartLineItems = (marketInfoList) => {
  const smartLineItems: SmartLineItemsItem[] = [];
  marketInfoList.forEach((i) => {
    const smartLineItem = {
      GameName: i.GameName,
      Name: i.ResultName,
      ResultId: "",
    };
    smartLineItems.push(smartLineItem);
  });
  return smartLineItems;
};

export const BetBuilderPlacementSrurce = "4000";
